import { useSafeApiCall, useApiClient } from "src/hooks/api";
import type { DomainLoanApplicationDetails } from "@porchpass/api-client";
import { zeroDate } from "src/constants";

export const useApplicationUpdater = () => {
  const safeApiCall = useSafeApiCall();
  const { fetchFromApi } = useApiClient();

  return async (
    fieldsToUpdate: Partial<DomainLoanApplicationDetails>,
    dealer_id: string,
    application_id: string,
    setApplication: React.Dispatch<
      React.SetStateAction<DomainLoanApplicationDetails>
    >,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    const isTargetDelivery = fieldsToUpdate.target_delivery_date !== undefined;
    const isTargetFunding = fieldsToUpdate.target_funding_date !== undefined;
    const isStatusUpdate = fieldsToUpdate.application_status !== undefined;

    const isDateRemoved =
      fieldsToUpdate.target_delivery_date === zeroDate ||
      fieldsToUpdate.target_funding_date === zeroDate;

    let successMessage = "Application updated";
    if (isStatusUpdate) {
      successMessage = "Application status updated";
    } else if (isTargetDelivery) {
      successMessage = `Target delivery date ${isDateRemoved ? "removed" : "updated"}`;
    } else if (isTargetFunding) {
      successMessage = `Target funding date ${isDateRemoved ? "removed" : "updated"}`;
    }

    const path = `/dealer-portal/v1/${dealer_id}/applications/${application_id}`;

    const { application_status, ...rest } = fieldsToUpdate;
    const apiPayload: Record<string, unknown> = { ...rest };
    if (application_status !== undefined) {
      apiPayload.status = application_status;
    }

    setIsLoading(true);

    return safeApiCall(
      () => fetchFromApi(path, { method: "PATCH", body: apiPayload }),
      {
        toastSuccessMsg: successMessage,
        toastErrorMsg: "Error updating application",
      },
    )
      .then(() => {
        setApplication((prev) => ({
          ...prev,
          ...fieldsToUpdate,
        }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
};
